import { Typography, Button, Grid } from '@mui/material';

import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { useModalStore } from '../../../zustandStore/store.attributes';

function ProductHeader() {
  const state = useModalStore((state) => state);
  const action = state.actions;
  const user = {
    name: 'Product for Prizeet',
    avatar: '/static/images/avatars/1.jpg'
  };
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography variant="h3" component="h3" gutterBottom>
          Products
        </Typography>
      </Grid>
      <Grid
        display={'flex'}
        sx={{
          width: 320
        }}
        item
      >
        <Button
          sx={{
            mt: { xs: 2, md: 0 },
            marginRight: '3%'
          }}
          variant="contained"
          onClick={(e) => action.setBulkUpload(true)}
          startIcon={<AddTwoToneIcon fontSize="small" />}
        >
          Bulk Upload
        </Button>
        <Button
          sx={{ mt: { xs: 2, md: 0 } }}
          variant="contained"
          onClick={(e) =>
            action.setModal({
              modalOpen: true
            })
          }
          startIcon={<AddTwoToneIcon fontSize="small" />}
        >
          Create Product
        </Button>
      </Grid>
    </Grid>
  );
}

export default ProductHeader;
